import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=25d3dc04&scoped=true&"
import script from "./Currency.vue?vue&type=script&lang=js&"
export * from "./Currency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d3dc04",
  null
  
)

export default component.exports